module.exports = __webpack_public_path__ + "static/img/ios_vi.5fa9c074.png";